import * as React from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useHistory } from 'react-router-dom';
import { SessionContext } from '../context/Session';
import PageHeader from '../components/PageHeader';
import wreathPic from '../assets/gallery/Blue and silver Christmas wreath.jpg';
import canvasPic from '../assets/gallery/Arcing wave primary.jpg';
import flowerPic from '../assets/gallery/Spring blue vase_primary.jpg';

export default function CustomOrdersView() {
  let history = useHistory();
  const { allRoutes } = React.useContext(SessionContext);

  React.useEffect(() => {
    console.log(allRoutes);
  }, []);

  const storeItems = [
    {
      title: 'Canvas',
      description: [],
      pic: '',
    },
    {
      title: 'Flowers',
      description: [],
    },
    {
      title: 'Wreaths',
      description: [],
    },
  ];
  const pageHeader = {
    title: `Custom Orders`,
    description:
      "Multiple lines of text that form the lede, informing new readers quickly and efficiently about what's most interesting in this post's contents.",
    image: 'https://source.unsplash.com/random',
    imageText: 'main image description',
  };
  return (
    <React.Fragment>
      <Container
        disableGutters
        maxWidth='2xl'
        component='main'
        sx={{
          display: 'flex',
          width: '100%',
          marginBottom: 12,
          alignItems: 'center',
          justifyContent: 'space-around',
          flexDirection: 'column',
        }}
      >
        <PageHeader post={pageHeader} />
        <Container maxWidth='md' component='main'>
          <Grid container spacing={5} alignItems='center'>
            {storeItems.map((item, idx) => (
              <Grid item key={item.title} xs={12} sm={6} md={4}>
                <Card>
                  <CardHeader
                    title={item.title}
                    titleTypographyProps={{
                      align: 'center',
                      variant: 'primary',
                      fontSize: 40,
                    }}
                    subheaderTypographyProps={{
                      align: 'center',
                    }}
                    sx={{
                      backgroundColor: (theme) => theme.palette.primary.main,
                    }}
                  />
                  <CardContent>
                    <img
                      src={
                        idx === 0
                          ? canvasPic
                          : idx === 1
                          ? flowerPic
                          : wreathPic
                      }
                      width='100%'
                    />
                  </CardContent>
                  <CardActions style={{ justifyContent: 'center' }}>
                    <Button
                      size='small'
                      variant='contained'
                      onClick={() => {
                        return history.push(`/custom-order`, {
                          type: item.title.toLowerCase(),
                        });
                      }}
                    >
                      Custom {item.title}
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Container>
    </React.Fragment>
  );
}
